module.exports = (keywords, options) => {
  let single = false
  if (typeof keywords === 'string') {
    keywords = [keywords]
    single = true
  }

  options = Object.assign({}, {
    trim_all: true,
    lower_case: true,
    replace_alt_apostrophes: true,
    remove_invalid_chars: true,
  }, options)

  keywords = keywords.map(keyword => {
    try {
      if(options.lower_case) {
        keyword = keyword.toLowerCase()
      }

      if(options.replace_alt_apostrophes) {
        keyword = keyword.replace('’', '\'')
      }

      if(options.remove_invalid_chars) {
        // keyword = keyword.replace(/[^0-9a-záàâäȧāãçéèêëęíîïīłƚṇñóôöøɵōõšṣẗţṭúùûüÿžẓæœаАбБвВгГдДеЕёЁжЖзЗиИйЙкКлЛмМнНоОпПрРсСтТуУфФхХцЦчЧшШщЩъЪыЫьЬэЭюЮяЯαβγδεζηθικλμνξοπρστυφχψω \-().?!#@$€'&]/g, '')
      }

      if(options.trim_all) {
        keyword = keyword.trim()
      }

      return keyword
    } catch (e) {
      return ''
    }
  })

  if (single) return keywords[0]
  else return keywords
}
